import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

export function useVisitorManagementUnvalidatedCredentialHold() {
  const isEnabled = useFlag<boolean>(
    FeatureFlag.VisitorManagementUnvalidatedCredentialHold,
    false
  );

  return Boolean(isEnabled);
}
